import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-[66px] justify-between p-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Orders")
  ])
], -1)
const _hoisted_4 = { class: "flex justify-between px-5 py-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "flex flex-col gap-2 overflow-x-auto p-5" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"box-head-blank justify-between\"><div class=\"flex gap-4 items-center\"><div class=\"w-44\"><span class=\"text-order\">Order ID</span></div><div class=\"w-36\"><span class=\"text-order\">Store</span></div><div class=\"w-36\"><span class=\"text-order\">Customer</span></div><div class=\"w-36\"><span class=\"text-order\">Driver</span></div><div class=\"w-24\"><span class=\"text-order\">Ordered</span></div><div class=\"w-24\"><span class=\"text-order\">Delivered</span></div><div class=\"w-28\"><span class=\"text-order\">Deliver Time</span></div><div class=\"flex justify-center w-24\"><span class=\"text-order\">Type</span></div><div class=\"flex justify-center w-24\"><span class=\"text-order\">Payment</span></div></div><div class=\"flex gap-4 justify-end\"><div class=\"flex justify-center w-36\"><span class=\"text-order\">Status</span></div><div class=\"flex justify-end w-16\"><span class=\"text-order\">Total</span></div></div></div>", 1)
const _hoisted_8 = ["to", "onClick"]
const _hoisted_9 = { class: "flex gap-4 items-center" }
const _hoisted_10 = { class: "w-44" }
const _hoisted_11 = { class: "text-title" }
const _hoisted_12 = { class: "w-36" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "w-36" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "w-36" }
const _hoisted_17 = {
  key: 0,
  class: "text"
}
const _hoisted_18 = { class: "flex flex-col w-24" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "flex flex-col w-24" }
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "w-28" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "flex justify-center w-24" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cash")
], -1)
const _hoisted_29 = { class: "flex gap-4 items-center" }
const _hoisted_30 = { class: "flex justify-center w-36" }
const _hoisted_31 = { class: "flex justify-end w-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseAutocomplete = _resolveComponent("BaseAutocomplete")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_BaseAutocomplete, {
              itemsOrder: _ctx.orders,
              itemsStore: _ctx.store,
              storeItemText: _ctx.joinedByStoreId,
              userItemText: _ctx.joinedByCustomerId,
              filterOrder: _ctx.OrderFilter,
              onFilter: _ctx.updateData,
              onClose: _ctx.updateData
            }, null, 8, ["itemsOrder", "itemsStore", "storeItemText", "userItemText", "filterOrder", "onFilter", "onClose"])
          ]),
          _: 1
        }))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, ({
                                Id,
                                UniqueId,
                                Store: {
                                    Name
                                },
                                Customer: {
                                    FirstName,
                                    LastName
                                },
                                Driver,
                                PlacedAt,
                                DeliveredAt,
                                DeliveryType,
                                Status,
                                DiscountedTotal
                            }, Idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "box-blank justify-between min-w-max cursor-pointer",
            key: Idx,
            to: { name: 'orders-id', params: { id: Id } },
            onClick: ($event: any) => (_ctx.$router.push(`/order/${Id}`))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(UniqueId), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(Name), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(FirstName + ' ' + LastName), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (Driver !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(Driver.FirstName+ ' '+ Driver.LastName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.helpers.formatDate(new Date(PlacedAt), 'HH:mm')), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.helpers.formatDate(new Date(PlacedAt), 'd.M.yyyy')), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(DeliveredAt ? _ctx.helpers.formatDate(new Date(DeliveredAt), 'HH:mm') : ' '), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(DeliveredAt ? _ctx.helpers.formatDate(new Date(DeliveredAt), 'd.M.yyyy') : ' '), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getDeliverTime(PlacedAt, DeliveredAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.helpers.upperFirst(DeliveryType)), 1)
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", {
                  class: "button-order-status",
                  style: _normalizeStyle({'color': `${_ctx.helpers.getOrderStatusColor(Status)}`, 'background-color': `${_ctx.helpers.getOrderStatusBackgroundColor(Status)}`})
                }, [
                  _createElementVNode("span", null, _toDisplayString(Status), 1)
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", {
                  class: "text-title",
                  style: _normalizeStyle(`color: #${Status === 'delivered' ? '515151': 'D1D3D6'}`)
                }, _toDisplayString(_ctx.helpers.toCurrency(DiscountedTotal)), 5)
              ])
            ])
          ], 8, _hoisted_8))
        }), 128)),
        _createVNode(_component_Pagination, {
          pagination: _ctx.Pagination,
          onUpdatePage: _ctx.updateData
        }, null, 8, ["pagination", "onUpdatePage"])
      ])
    ])
  ]))
}